<div class="pir-pagecontainer">
  <div class="pir-divcontainer">
    <div class="pir-message" role="alert">{{ message }}</div>
    <div class="pir-detail">Click <a href="/">here</a> to go back.</div>
  </div>
</div>
